<template>
  <div class="page-container">
    <div class="specialist-goals-child-screening">
      <div class="child-card">
        <div class="top-section">
          <div class="left-info">
            <div class="circle"></div>
            <div class="child-info">
              <h2>{{ specialist.name }}</h2>
              <p class="details">{{ specialist.email}} | {{ specialist.phone_number }}</p>
              <p class="details">{{ specialist.site}}</p>
              <p class="details">Type of specialist: {{ specialist.type_of_specialist}}</p>
            </div>
          </div>
          <div class="right-top-section">
            <div class="actions">
                <button class="edit-profile" @click="showEditModal = true">Edit Profile</button>
            </div>
          </div>
        </div>
      </div>
      <div class="stat-card">
          <div class="screening-grid">
            <div class="mini-card">
              <div class="screening-header">
              <h3>Specialist Statistics</h3>
                </div>
                <div class="stats-grid">
                  <!-- Stat 1 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="10" y="25" width="5" height="15" fill="#000" stroke="#000" stroke-width="0.75"  />
                                    <rect x="22" y="15" width="5" height="5" fill="#000" stroke="#000" stroke-width="0.75"  />
                                    <rect x="22" y="25" width="5" height="15" fill="#000" stroke="#000" stroke-width="0.75"  />
                                    <rect x="34" y="10" width="5" height="30" fill="#000" stroke="#000" stroke-width="0.75"  />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.specialist_stats.total_patients }}</div>
                      <div class="stat-label">Total Patient/Students</div>
                    </div>
                  </div>

                  <!-- Stat 2 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="15" y="10" width="20" height="20" fill="none" stroke="#000000" stroke-width="2" rx="20"/>
                                    <line x1="23" y1="25" x2="30" y2="15" style="stroke:black;stroke-width:2" />
                                    <line x1="19" y1="20" x2="24" y2="25" style="stroke:black;stroke-width:2" />
                                    <line x1="30" y1="29" x2="35" y2="38" style="stroke:black;stroke-width:2" />
                                    <line x1="25" y1="34" x2="35" y2="38" style="stroke:black;stroke-width:2" />
                                    <line x1="15" y1="38" x2="25" y2="34" style="stroke:black;stroke-width:2" />
                                    <line x1="20" y1="29" x2="15" y2="38" style="stroke:black;stroke-width:2" />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.specialist_stats.average_severity }}</div>
                      <div class="stat-label">Average Severity</div>
                      <div class="stat-subtext">Out of 5</div>
                    </div>
                  </div>

                  <!-- Stat 3 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="15" y="15" width="20" height="20" fill="none" stroke="#000000" stroke-width="2" rx="20"/>
                                    <rect x="21.75" y="11" width="7" height="2" fill="#000000" stroke-width="1"/>
                                    <line x1="33" y1="18" x2="35" y2="16" style="stroke:black;stroke-width:2" />
                                    <path x="15" y="15" width="15" height="15" fill="none" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M16 25 h4 l2-4 l3 8 l2-4 h7" />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.specialist_stats.average_age }}</div>
                      <div class="stat-label">Average Age</div>
                      <div class="stat-subtext">Of Patients/Students</div>
                    </div>
                  </div>
                  <!-- Stat 4 -->
                  <div class="stat-item">
                    <div class="icon-box">
                      <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="2" y="2" width="46" height="46" fill="none" stroke="black" stroke-width="3" rx="6" />
                                    <rect x="12.5" y="15" width="25" height="25" fill="none" stroke="black" stroke-width="2" rx="4" />
                                    <rect x="24" y="12" width="3" height="3" fill="none" stroke="black" stroke-width="1.5" rx="2" />
                                    <rect x="16" y="20" width="17.5" height="2" fill="black" strokr-width="1.5" />
                                    <rect x="16" y="26" width="17.5" height="2" fill="black" strokr-width="1.5" />
                                    <rect x="16" y="32" width="10.5" height="2" fill="black" strokr-width="1.5" />
                                  </svg>
                    </div>
                    <div class="stat-text">
                      <div class="stat-number">{{ analytics.specialist_stats.upcoming_scheduled }}</div>
                      <div class="stat-label">Upcoming Scheduled Activites</div>
                      <div class="stat-subtext link">This month</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mini-card">
                <h3>Age Distribution</h3>
                <div class="label">By biological age</div>
                <div class="breakdown-container">
                    <BarChartEChart2
                    :data-input="ageGraph"
                    :bar-colors="['#f6a620', '#dc6803', '#93370d','#f6a620', '#dc6803', '#93370d','#f6a620', '#dc6803', '#93370d','#f6a620', '#dc6803', '#93370d','#f6a620', '#dc6803', '#93370d','#f6a620', '#dc6803', '#93370d']"
                    />
                </div>
            </div>
                <div class="mini-card">
                <h3>Severity Distribution</h3>
                <div class="label"># of Patients/Students in that severity</div>
                <div class="breakdown-container">
                    <BarChartEChart2
                    :data-input="severityGraph"
                    :bar-colors="['#f6a620', '#dc6803', '#93370d','#f6a620', '#dc6803']"
                    />
                </div>
            </div>
          </div>
        </div>
        <div class="activity-information-card">
        <div class="header">
            <h4>Patient/Student Breakdown</h4>
        </div>
          <div class="activity-scroll">
          <table class="activity-table">
            <thead>
              <tr>
                <th @click="toggleSort('childName')">Patient/Student Name</th>
                <th @click="toggleSort('age')">Age</th>
                <th @click="toggleSort('severity')">Severity</th>
                <th @click="toggleSort('upoming')">Upcoming Activites</th>
              </tr>
            </thead>
                <tbody>
                  <template v-if="analytics && analytics.student_breakdown && analytics.student_breakdown.length > 0">
                    <tr v-for="activity in analytics.student_breakdown" :key="activity.activity_id">
                      <td>{{ activity.first_name }} {{ activity.last_name }}</td>
                      <td><span class="type">{{ activity.age }}</span></td>
                      <td>{{ activity.severity }}</td>
                      <td>{{ activity.upcoming_activites }}</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td>N/A</td>
                      <td><span class="type">0</span></td>
                      <td>0</td>
                      <td>0</td>
                      <td>Stable</td>
                    </tr>
                  </template>
                </tbody>
            </table>
          </div>
        </div>
      </div>
      <div 
        v-if="showEditModal"
        class="modal-overlay"
        >
        <div class="edit-modal">
            <div class="modal-header">
            <h2>Edit Profile</h2>
            <button 
                class="close-button"
                @click="showEditModal = false"
            >
                ✕
            </button>
            </div>
            <div class="form-grid">
            <div class="form-group">
                <label>Specialist First Name</label>
                <input v-model="analytics.first_name">
            </div>
            <div class="form-group">
                <label>Specialist Last Name</label>
                <input v-model="analytics.last_name">
            </div>
            <div class="form-group">
                <label>Email</label>
                <input v-model="specialist.email">
            </div>
            <div class="form-group">
                <label>Phone</label>
                <input v-model="specialist.phone_number">
            </div>
            <div class="form-group">
                <label>Type of Specialist</label>
                  <select 
                    class="specialist-select"
                    v-model="specialist.type_of_specialist"
                  >
                    <option value="">Not a Specialist</option>
                    <option value="Child Counselor">Child Counselor</option>
                    <option value="Language Therapist">Language Therapist</option>
                    <option value="Neuro-pediatrician">Neuro-pediatrician</option>
                    <option value="Occupational Therapist (OT)">Occupational Therapist (OT)</option>
                    <option value="Occupational Therapist Assistant (OTA)">Occupational Therapist Assistant (OTA)</option>
                    <option value="Physical Therapist/Kinesiologist">Physical Therapist/Kinesiologist</option>
                    <option value="Psychotherapist">Psychotherapist</option>
                    <option value="Psychologist">Psychologist</option>
                    <option value="Reading Specialist (RSP)">Reading Specialist (RSP)</option>
                    <option value="Social Worker">Social Worker</option>
                    <option value="Special Education Teacher">Special Education Teacher</option>
                    <option value="Speech & Language Pathologist (SLP)">Speech & Language Pathologist (SLP)</option>
                    <option value="Speech & Language Pathologist Assistant (SLPA)">Speech & Language Pathologist Assistant (SLPA)</option>
                    <option value="Speech Therapist">Speech Therapist</option>
                  </select>
            </div>
            </div>
            <div class="modal-actions">
            <button
                class="cancel"
                @click="showEditModal=false"
            >
                Cancel
            </button>
            <button
                class="save"
                @click="saveProfile"
            >
                Save Changes
            </button>
            </div>
        </div>
      </div>
  </div>
</template>


<script>
import BarChartEChart2 from './subComponents/BarChartECharts2.vue'
import axios from "axios";

export default {
  name: 'OrganizationIndividualSpecialist',

  props: {
    childID: {
      type: String,
      required: true,
    },
    area: {
      type: String,
      default: null
    },
  },
  components:{
    BarChartEChart2,
  },

  data() {
    return {
      showEditModal: false,
      specialist: {},

      analytics: {},

      clickSort: "childNameASC"
    }
  },


  methods: {
    saveProfile(){

    console.log("Updated profile:", this.child)

    this.showEditModal = false;
    this.updateProfile();

    },
    async updateProfile(){
      console.log("Saving note:", this.message);

      const specialistID = this.$route.params.specialistID;
      const baseUrl =
        process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

      try {
        const resp = await fetch(`${baseUrl}/api/specialist/${specialistID}/profile`, {
          method: "PATCH", 
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: this.analytics.first_name, 
            last_name: this.analytics.last_name,
            email: this.specialist.email,
            phone_number: this.specialist.phone_number,
            type_of_specialist: this.specialist.type_of_specialist
          }),
        });

        if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);

        const data = await resp.json();
        console.log("Update successful:", data);

        await this.getSpecialist();

      } catch (err) {
        console.error("Error updating note:", err);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },


    pairCategories(activity) {

      const names =
        activity.category
          ? activity.category.split(",").map(s=>s.trim())
          : [];

      const scores =
        activity.category_score
          ? activity.category_score.split(",").map(s=>s.trim())
          : [];


      return names.map((name,i)=>({
        name,
        score:scores[i] || ""
      }));

    },

    toggleSort(field){

      if (this.clickSort === field + "ASC") {
          this.clickSort = field + "DESC"
      } else {
          this.clickSort = field + "ASC"
      }

      this.getSpecialist()
    },
    async getSpecialist() {
      try {

          const specialistID = this.$route.params.specialistID;
          const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

          const response = await axios.get(`${baseUrl}/api/specialist/${specialistID}/individual-specialist`,
              {
                  params: {
                      clickSort: this.clickSort
                  }
              }
          );

          this.analytics = response.data;

          this.specialist = {
              name:
                  response.data.first_name +
                  " " +
                  response.data.last_name,

              email: response.data.email,

              phone_number: response.data.phone_number,

              site: response.data.org_name,

              type_of_specialist:
                  response.data.type_of_specialist
          }

      } catch(err){
          console.error(err)
      }
  }
  },


  computed: {
    breakdownData(){
      if(!this.analytics.breakdown)
        return [];
      return this.analytics.breakdown.elements.map(
        (el,i)=>({

          variable:el,

          value:
            Number(
              this.analytics.breakdown.scores[i]
            ) || 0

        })
      );
    },
    ageGraph() {
        if (!this.analytics.age_distribution)
            return []
        return this.analytics.age_distribution.ages.map((age, index) => ({
            variable: age.toString(),
            value: this.analytics.age_distribution.num_of_age[index]
        }))
    },
    severityGraph() {
      if (!this.analytics.severity_distribution)
          return []
      return this.analytics.severity_distribution.severities.map(
          (severity,index)=>({
              variable: severity.toString(),
              value:
                  this.analytics
                      .severity_distribution
                      .num_of_severity[index]
          })
      )
  }
  },
  async mounted() {
    await this.getSpecialist()
  }

};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background: white;
}
.side-nav-fixed {
  position: fixed;
  top: 70px;
  left: 0;
  width: 15%;
  height: calc(100vh - 60px);
  background: #f4f4f4;
  padding: 24px;
  border-right: 1px solid #e5e5e5;
  font-size: 15px;
  color: #333;
  display: flex;
  flex-direction: column;

  a{
    text-decoration: none;
    color: #333;
    padding: 10px 0;
    transition: 0.2s;
  }
  .side-nav-fixed active-link {
  font-weight: bold;
  color: #9D5f0E;
  }
}

.specialist-goals-child-screening {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.top-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.left-info {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
.child-card {
  background: white;
  padding: 32px;
  border-radius: 16px;
  border: 1px solid #eee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.row-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.profile-area {
  display: flex;
  align-items: center;
}
.circle {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  background: white;
  border: 3px solid #d89c29;
}
.child-info {
  margin-left: 18px;
  display: flex;
  flex-direction: column;
}
.child-info h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}
.details {
  font-size: 14px;
  color: black;
  margin: 2px 0;
}
.actions {
  display: flex;
  gap: 12px;
  margin-left: auto; 
}
.actions button {
  color: #9D5f0E;
  background: #FFF5E3;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
}
.actions button:hover {
  background: #ffe9c5;
}

.tabs {
  display: flex;
  gap: 5px;
  margin-top: 0px;
  border: 0.5px solid #ddd;
  border-radius: 8px;
  padding: 4px;
  height: 50px;
  width: 80%;
}
.tabs button {
  padding: 9px 18px;
  cursor: pointer;
  font-size: 10px;
  transition: 0.2s;
  border-radius: 8px;
  margin-top: 4px;
  margin-bottom: 8px;
}
.tabs button:hover {
  background: #f2f2f2;
}
.tabs .active {
  color: #9D5f0E;
  background-color: #FFF5E3;
  border-radius: 8px;
  font-weight: 600;
}
.sections {
  display: flex;
  justify-content: space-between;
  margin-top: 28px;
  gap: 20px;
}
.section {
  flex: 1;
  min-width: 0;
}
.section h3 {
  font-size: 16px;
  margin-bottom: 10px;
  color: black;
}
.right-top-section{
  display:flex;
  flex-direction: column;
}

.tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.strength-tag {
  padding: 6px 12px;
  background: #FFF5E3;
  border: 1px solid #f3b944;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  color:#9D5f0E
}
.focus-tag {
  padding: 6px 12px;
  background: #ffebeb;
  border: 1px solid #ec6060;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  color: #404b52;
}
.assessment-card {
  border: none;
  max-width: 900px;
  width: 100%;
}
.intervention-card {
  border: none;
  max-width: 900px;
  width: 100%;
}
.screening-card {
  border: none;
  max-width: 900px;
  width: 100%;
}

.stat-card {
  padding: 16px;
  border-radius: 12px;
  margin-top: 20px;
  max-width: 932px;
  width: 100%;
  margin-left: none;
  margin-right: none;
  border: none;
}
.screening-grid, .assesment-grid, .intervention-grid {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}
.screening-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sort-by{
  display: flex;
  align-items: center;
  color: #9D5f0E;
  background: #FFF5E3;
  border-radius: 8px;
  padding: 4px 10px;
  gap: 6px;
  width: fit-content;

  label {
    font-size: 16px;
    color: gray;
    margin: 0;
  }
  select {
    appearance: none; 
    border: none;
    color: #9D5f0E;
    background: #FFF5E3;
    font-size: 16px;
    padding: 6px 24px 6px 0;
    cursor: pointer;
    outline: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' stroke='%239D5f0E' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 8l4 4 4-4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 4px center;
    background-size: 16px 16px;
  }
}
.mini-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-height: 160px;
  display: flex;
  flex-direction: column;
}
.mini-card h3 {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: black;
}
.pill-toggle, .semester-row{
  display: flex;
  padding: 4px;
  border: none;

  button {
    background: none;
    border: 1px solid black;
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    color: black;
    justify-content: space-between;

    &.active {
      background: black;
      color: white;
      font-weight: 600;
    }
  }
}
.legend{
  display: flex;
  color: black;
  justify-content: right;
  font-size: 12px;
  padding-right: 4px;
  padding-left: 4px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px 40px;
  margin-top: 20px;
}

.stat-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.icon-box {
  min-width: 45px;
  height: 45px;
  background: #f3f4f6;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: black;
}

.stat-label {
  font-size: 12px;
  color: #444;
}
.label {
  font-size: 12px;
  color: #444;
  justify-content: center;
}
.stat-subtext {
  font-size: 12px;
  color: #777;
}

.stat-subtext.positive {
  color: #16a34a;
  font-weight: 500;
}

.stat-subtext.link {
  color: #2563eb;
  font-weight: 500;
}

.progress-over-time{
  flex: 1;
  margin-top: 1%;
}
.breakdown-container{
  height: 100%;
  justify-content: center;
}
.tag-row{
  display: flex;
  align-items: center;
  flex-direction: row;
}
.tag-column-1, .tag-column-2, .tag-column-3, .tag-column-4{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.shift-up{
  display: flex;
  height: 70%;
  width: 70%;
  margin-top: -30px;
}
.shift-down{
  display: flex;
  height: 70%;
  width: 70%;
}
.stacked-text{
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: left;
  padding-right: 2px;
}
.mini-mini-card{
  font-size: 10px;
  color: black;
  justify-content: left;
  padding-right: 2px;
  .number{
    font-size: 12px;
    font-weight: 600;
    justify-content: left;
    padding-right: 2px;
  }
  .small-text{
    font-size:8px;
    justify-content: left;
    padding-right: 2px;
    padding-bottom: 2px;
  }
}

.activity-information-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-height: 160px;
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  margin-left: none;
  margin-right: none;
  border: none;
}
.activity-information-card h4 {
  font-size: 20px;
  font-weight: 600;
  color: black;
}
.background-information-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  border: 1px solid #eee;
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-height: 160px;
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  margin-left: none;
  margin-right: none;
  border: none;
}
.header{
  flex: 1;
  border:none;
}
.add-note{
border: 1px solid #9D5f0E;
color: #9D5f0E;
padding: 6px 12px;
border-radius: 4px;
}
.add-note:hover{
    border: 1px solid #9D5f0E;
    color: #9D5f0E;
    background: #FFF5E3;
  }
  .add-note .active{
    border: 1px solid #9D5f0E;
    color: #9D5f0E;
    background: #FFF5E3;
  }
.background-information-card h5 {
  font-size: 16px;
  font-weight: 600;
  color: black;
  justify-content: left;
  margin: 0 0px;
}
.background-information-card p {
  font-size: 14px;
  color: black;
  margin: 0 0px;
  padding-top: 1px;
}
.info-card-wrapper {
  margin-top: 10px;
  max-width: 932px;
  width: 100%;
  padding: 16px
}
.activity-scroll {
  max-height: 400px;
  overflow-y: auto;
  border: none;
  border-top: none;
}
.activity-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;

  th,
  td, tr, ts {
    padding: 0.75rem;
    border-bottom: 1px solid #ccc;  
    text-align: center;
  }
  thead {
    position: relative; 
    font-size: 14px;
    color: black;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;      
        left: 50%;      
        transform: translateX(-50%);
        width: 104%; 
        border-bottom: 1px solid black;
        pointer-events: none;  
    }
    th {
        border-bottom: none;  
        font-weight: 400;
    }
  }
  tbody {
    font-weight: 400;
    font-size: 14px;
  }
}
.category,
.type {
  display: inline-block;
}

.category {
  padding: 2px 10px;
  background: #ffebeb;
  border: 1px solid #ec6060;
  border-radius: 999px;
  color: #404b52;
}

.type {
  padding: 6px 12px;
  background: #FFF5E3;
  border: 1px solid #f3b944;
  border-radius: 999px;
  color: #9D5f0E;
}
.note-text-box{
  border:#777;
  margin-top: 8px;
  width:100%;
  display: flex;
  flex-direction: column;
}
.graph-button {
    color: white !important;
    display: inline-block;
    padding: 10px 16px;
    border: none;
    border-radius: 8px;
    text-decoration: none;

    font-size: 14px;
    font-weight: 600;

    text-decoration: none; 

    background: #9D5F0E;
    cursor: pointer;
    transition: 0.2s ease;
}
.graph-button:hover {
    background: #9D5F0E 10%;
    color: white !important;
    text-decoration: none;
}
.urgency-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 90px;
  padding: 5px 14px;

  border-radius: 999px;

  font-size: 12px;
  font-weight: 600;
}

/* green */
.urgency-badge.stable {
  background: #e8f7ee;
  color: #15803d;
  border: 1px solid #22c55e;
}

/* yellow */
.urgency-badge.can-manage {
  background: #fff7db;
  color: #b45309;
  border: 1px solid #facc15;
}

/* red */
.urgency-badge.critical {
  background: #ffe8e8;
  color: #dc2626;
  border: 1px solid #ef4444;
}
.modal-overlay {

  position: fixed;
  inset: 0;

  background: rgba(0,0,0,0.35);

  display:flex;
  justify-content:center;
  align-items:center;

  z-index:1000;

}


.edit-modal {

  width:600px;
  max-height:80vh;

  background:white;

  border-radius:16px;

  display:flex;
  flex-direction:column;
  padding:28px;

  box-shadow:
    0 20px 50px rgba(0,0,0,0.25);

  animation: pop .2s ease;

}


@keyframes pop {

  from {
    transform:scale(.95);
    opacity:0;
  }

  to {
    transform:scale(1);
    opacity:1;
  }

}


.modal-header {

  display:flex;
  justify-content:space-between;
  align-items:center;

  margin-bottom:20px;

}


.close-button {

  border:none;
  background:none;

  font-size:22px;
  cursor:pointer;

}



.form-grid {

 max-height:55vh;

  overflow-y:auto;   

  overflow-x:hidden; 

  padding-right:10px;

  display:grid;
  grid-template-columns:1fr 1fr;
  gap:18px;

}


.form-group {

  display:flex;
  flex-direction:column;
  gap:6px;

}


.form-group label {

  font-size:13px;
  font-weight:600;

}


.form-group input,
.form-group select {

  padding:10px;

  border-radius:8px;

  border:1px solid #ddd;

  max-width: 300px;

}
.form-group select{
  appearance:none;
  padding-right: 40px;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' stroke='gray' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 8l4 4 4-4' stroke-width='0.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-position: right 4px center;
}


.modal-actions {

  margin-top:25px;

  display:flex;
  justify-content:flex-end;

  gap:12px;

}


.cancel {

  background:white;
  border:1px solid #ddd;

  padding:10px 18px;
  border-radius:8px;

}


.save {

  background:#9D5F0E;
  color:white;

  border:none;

  padding:10px 18px;
  border-radius:8px;

}
</style>